function dropDownSwitch(classToSwitch) {
  var x = document.getElementsByClassName(classToSwitch)[0];
  if (x.style.display === "flex") {
    x.style.display = "none";
  } else {
    x.style.display = "flex";
  }
}

function product_expand(imgs) {
  var expandImg = document.getElementById("product_expanded");
  expandImg.src = imgs.src;
}

function showFrequency() {
  var frequencyElem = document.getElementById("frequency");
  frequencyElem.style.display = "block";
  var div1 = document.getElementById("pill-reg");
  div1.style.border = "1px solid var(--clr-pearly)";
  var div2 = document.getElementById("pill-sub");
  div2.style.border = "2px solid var(--clr-pearly)";
}

function hideFrequency() {
  var frequencyElem = document.getElementById("frequency");
  frequencyElem.style.display = "none";
  var div2 = document.getElementById("pill-sub");
  div2.style.border = "1px solid var(--clr-pearly)";
  var div1 = document.getElementById("pill-reg");
  div1.style.border = "2.5px solid var(--clr-pearly)";
}
